"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _accountMenu = _interopRequireDefault(require("./account-menu"));

var _pill = _interopRequireDefault(require("../pill"));

var _nav = _interopRequireDefault(require("./nav.scss"));

var Navigation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Navigation, _React$Component);

  function Navigation() {
    var _this;

    (0, _classCallCheck2["default"])(this, Navigation);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Navigation).call(this));
    _this.state = {
      accountNavActive: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Navigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$cartItemC = _this$props.cartItemCount,
          cartItemCount = _this$props$cartItemC === void 0 ? 0 : _this$props$cartItemC,
          CartLink = _this$props.cartLink,
          accountLink = _this$props.accountLink,
          _this$props$accountMe = _this$props.accountMenuItems,
          accountMenuItems = _this$props$accountMe === void 0 ? [] : _this$props$accountMe,
          displayAccount = _this$props.displayAccount;
      var displayAccountMenu = accountMenuItems.length > 0;
      var cartLinkIsString = typeof CartLink === 'string';
      var CartLinkElement = cartLinkIsString ? _react["default"].createElement("a", null) : CartLink;
      var cartLinkProps = cartLinkIsString ? {
        href: CartLink
      } : {};
      return _react["default"].createElement("div", {
        className: _nav["default"].container
      }, _react["default"].createElement("nav", {
        className: _nav["default"].nav
      }, _react["default"].cloneElement(CartLinkElement, cartLinkProps, _react["default"].createElement("section", {
        "aria-label": "".concat(cartItemCount, " items in your cart")
      }, "Cart", cartItemCount > 0 && _react["default"].createElement(_pill["default"], {
        className: _nav["default"].cartItems
      }, cartItemCount))), displayAccount && (displayAccountMenu ? _react["default"].createElement(_accountMenu["default"], {
        items: accountMenuItems
      }) : _react["default"].createElement("a", {
        href: accountLink
      }, "Account"))));
    }
  }]);
  return Navigation;
}(_react["default"].Component);

Navigation.defaultProps = {
  displayAccount: false
};
Navigation.propTypes = {
  cartItemCount: _propTypes["default"].number,
  cartLink: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  accountLink: _propTypes["default"].string,
  accountMenuItems: _propTypes["default"].array,
  displayAccount: _propTypes["default"].bool
};
var _default = Navigation;
exports["default"] = _default;